export const SUBURBAN = ['house', 'cottage', 'townhouse', 'houseShare', 'dailyHouse'];
